export const SIZE = {
    A: 8,
    B: 16,
    BB: 18,
    C: 24,
    CC: 28,
    D: 32,
    E: 40,
    F: 48,
    G: 56,
    H: 64,
    NONE: 0,
};
